import type { EventType, LogLevel } from 'shared/services/logger/logger.types'

export type Mode = 'live' | 'file'
export type LevelFilter = LogLevel | 'all'
export type TypeFilter = EventType | 'all'
export type SortOrder = 'desc' | 'asc'
export type FilterLogic = 'and' | 'or'

export type ConditionField = 'event' | 'payload' | 'payload_field'
export type ConditionOperator =
  | 'contains'
  | 'not_contains'
  | 'equals'
  | 'not_equals'
  | 'starts_with'
  | 'ends_with'
  | 'exists'
  | 'not_exists'

export interface FilterCondition {
  id: string
  field: ConditionField
  payloadKey: string
  operator: ConditionOperator
  value: string
}

export const LOG_LEVELS: LogLevel[] = ['debug', 'info', 'warn', 'error']

export const EVENT_TYPES: EventType[] = [
  'error',
  'navigation',
  'action',
  'auth',
  'storage',
  'system'
]

export const OPERATORS_FOR_FIELD: Record<ConditionField, ConditionOperator[]> =
  {
    event: [
      'contains',
      'not_contains',
      'equals',
      'not_equals',
      'starts_with',
      'ends_with'
    ],
    payload: ['contains', 'not_contains'],
    payload_field: [
      'equals',
      'not_equals',
      'contains',
      'not_contains',
      'exists',
      'not_exists'
    ]
  }

export const NO_VALUE_OPS = new Set<ConditionOperator>(['exists', 'not_exists'])
